/**
 * @generated SignedSource<<08cd15962af1a7cc148d6a98b9e5f4f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BaselineVersionScaleDirection = "FEWER" | "MORE" | "%future added value";
export type CreateVersionPanelScalePreviewQuery$variables = {
  projectId?: string | null;
  scaleDirection: BaselineVersionScaleDirection;
  scalePercent: number;
};
export type CreateVersionPanelScalePreviewQuery$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly project: {
      readonly baselineScaledVersionPreview: {
        readonly revenue: number | null;
        readonly minutes: number | null;
        readonly margin: number | null;
      } | null;
    } | null;
  } | null;
};
export type CreateVersionPanelScalePreviewQuery = {
  variables: CreateVersionPanelScalePreviewQuery$variables;
  response: CreateVersionPanelScalePreviewQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scaleDirection"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scalePercent"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "baseline_version_preview"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"baseline_version_preview\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "scaleDirection",
      "variableName": "scaleDirection"
    },
    {
      "kind": "Variable",
      "name": "scalePercent",
      "variableName": "scalePercent"
    }
  ],
  "concreteType": "BaselineVersionSummary",
  "kind": "LinkedField",
  "name": "baselineScaledVersionPreview",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "margin",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateVersionPanelScalePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateVersionPanelScalePreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ec46a5199cb6fcfdbc3128b41ab5b69",
    "id": null,
    "metadata": {},
    "name": "CreateVersionPanelScalePreviewQuery",
    "operationKind": "query",
    "text": "query CreateVersionPanelScalePreviewQuery(\n  $projectId: ID\n  $scaleDirection: BaselineVersionScaleDirection!\n  $scalePercent: Int!\n) {\n  viewer {\n    component(name: \"baseline_version_preview\")\n    project(internalId: $projectId) {\n      baselineScaledVersionPreview(scaleDirection: $scaleDirection, scalePercent: $scalePercent) {\n        revenue\n        minutes\n        margin\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f1507156597cdee0815b11df6edc0ef";

export default node;
